import baseURL from "../common/axios";
class Commonservices {
  //To Load Branch/Department/Subdepartment-->HMS API
  getBranch(OrganizationId) {
    return baseURL.httpMSInventoryUrl.get(
      "/StoreMAS/LoadBranch?OrganizationId=" + OrganizationId + ""
    );
  }
  //To Load User-->HMS API
  getUser(dataModel) {
    return baseURL.httpbaseURL.post("Service_Master/ServiceMaster", dataModel);
  }

  //To Load Store Table-->Inventory API
  getStoreList(OrganizationId, BranchId) {
    return baseURL.httpMSInventoryUrl.get(
      "StoreMAS/List?OrganizationId=" + OrganizationId + "&BranchId=" + BranchId
    );
  }

  getStoreListByUserId(UserId, OrganizationId, IsAdmin, BranchId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StoreMAS/ListByUserId?UserId=" +
      UserId +
      "&OrganizationId=" +
      OrganizationId +
      "&IsAdmin=" +
      IsAdmin +
      "&BranchId=" +
      BranchId +
      ""
    );
  }

  StoreDropDownListByUserId(UserId, OrganizationId, IsAdmin, BranchId) {
    debugger;
    // return baseURL.httpMSInventoryUrl.get(
    //   "StoreMAS/ListByUserId?UserId=" +
    //   UserId +
    //   "&OrganizationId=" +
    //   OrganizationId +
    //   "&IsAdmin=" +
    //   IsAdmin +
    //   "&BranchId=" +
    //   BranchId +
    //   ""
    // );
    return baseURL.httpMSInventoryUrl.get(
      "StoreMAS/StoreDropDownListByUserId?UserId=" +
      UserId +
      "&OrganizationId=" +
      OrganizationId +
      "&IsAdmin=" +
      IsAdmin +
      "&BranchId=" +
      BranchId +
      ""
    );
  }

  GetAllStoreList(OrganizationId, BranchId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StoreMAS/ListCustomForUserCreate?OrganizationId=" +
      OrganizationId +
      "&BranchId=" +
      BranchId +
      ""
    );
  }

  StoreDropDownListCustomForUserCreate(OrganizationId, BranchId) {
    debugger;
    // return baseURL.httpMSInventoryUrl.get(
    //   "StoreMAS/ListCustomForUserCreate?OrganizationId=" +
    //   OrganizationId +
    //   "&BranchId=" +
    //   BranchId +
    //   ""
    // );
    return baseURL.httpMSInventoryUrl.get(
      "StoreMAS/StoreDropDownListCustomForUserCreate?OrganizationId=" +
      OrganizationId +
      "&BranchId=" +
      BranchId +
      ""
    );
  }

  ListByBranchId(UserId, OrganizationId, IsAdmin, BranchId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StoreMAS/ListByBranchId?UserId=" +
      UserId +
      "&OrganizationId=" +
      OrganizationId +
      "&IsAdmin=" +
      IsAdmin +
      "&BranchId=" +
      BranchId +
      ""
    );
  }
  //To Insert Store-->Inventory API
  insertStore(dataModel) {
    return baseURL.httpMSInventoryUrl.post("StoreMas/Create", dataModel);
  }
  //To Update Store-->Inventoer API
  updateStore(dataModel) {
    return baseURL.httpMSInventoryUrl.post("StoreMas/Update", dataModel);
  }
  //To Delete Store-->Inventory API
  deleteStore(Id) {
    return baseURL.httpMSInventoryUrl.delete("StoreMas/Delete?id=" + Id);
  }
  //Active
  active(Id, Status) {
    return baseURL.httpMSInventoryUrl.put(
      "StoreMas/Active?id=" + Id + "&Status=" + Status + ""
    );
  }
  //To Get Store By Id-->Inventory API
  getStore(Id, BranchId) {
    return baseURL.httpMSInventoryUrl.get("StoreMas/Get?id=" + Id + "&BranchId=" + BranchId);
  }
  //To Get Store Details By Id-->Inventory API
  getStoreDetailsById(Id, BranchId, HospitalId) {
    return baseURL.httpMSInventoryUrl.get(
      "StoreMas/GetStoreDetailsById?StoreId=" +
      Id +
      "&BranchId=" +
      BranchId +
      "&HospitalId=" +
      HospitalId
    );
  }
  GetByStoreIdAndBranchId(Id, BranchId) {
    return baseURL.httpMSInventoryUrl.get(
      "StoreMas/GetByStoreIdAndBranchId?StoreId=" +
      Id +
      "&BranchId=" +
      BranchId +
      ""
    );
  }
  //To Get Store DropDown By TypeId-->Inventory API
  getStoreByTypeId(storeTypeId) {
    return baseURL.httpMSInventoryUrl.get(
      "StoreMAS/GetStore?StoreTypeId=" + storeTypeId + ""
    );
  }
  //To Insert Store Mapping -->Inventory API
  insertStoreMapping(dataModel) {
    return baseURL.httpMSInventoryUrl.post("StoreMappingMAP/Create", dataModel);
  }
  //To Delete Store mapping-->Inventory API
  deleteStoreMapping(dataModel) {
    return baseURL.httpMSInventoryUrl.post("StoreMappingMAP/Update", dataModel);
  }
  //To get store based on Store
  getStoreByStoreId(storeId, OrganizationId, BranchId) {
    return baseURL.httpMSInventoryUrl.get(
      "Custom/GetStoreByStoreId?id=" +
      storeId +
      "&OrganizationId=" +
      OrganizationId +
      "&BranchId=" +
      BranchId
    );
  }
  //To get Department List(Authorize API)
  LoadDepartment() {
    return baseURL.httpMSInventoryUrl.get("Common/DepartmentList");
  }
  //To get Sub Department List(Authorize API)
  LoadSubDepartment() {
    return baseURL.httpMSInventoryUrl.get("Common/SubDepartmentList");
  }
  //To get UserList based on StoreId(Authorize API)
  ListUserByStoreId(StoreId, OrganizationId) {
    return baseURL.httpMSInventoryUrl.get(
      "StoreMas/ListUserByStoreId?StoreId=" +
      StoreId +
      "&OrganizationId=" +
      OrganizationId +
      ""
    );
  }
  insertStoreBranchMapping(dataModel) {
    return baseURL.httpMSInventoryUrl.post(
      "StoreMas/CreateStoreBranchMapping",
      dataModel
    );
  }
  GetBranchByStore(storeId) {
    return baseURL.httpMSInventoryUrl.get(
      "StoreMas/GetBranchByStoreID?id=" + storeId + ""
    );
  }
}
export default new Commonservices();
